import React from "react";
import PropTypes from "prop-types";
import IsMobileView from "../utils/mobileView";

/** Section titles on marketing / landing — centered to match hero; same rhythm as headline. */
const H2 = (props) => {
  const { color, children } = props;
  const mobile = IsMobileView();
  const style = {
    color,
    fontFamily: "inherit",
    fontWeight: 700,
    fontSize: mobile ? 28 : 34,
    letterSpacing: "-0.03em",
    lineHeight: 1.15,
    textAlign: "center",
    width: "100%",
    maxWidth: 720,
    marginTop: 0,
    marginBottom: mobile ? 16 : 20,
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: mobile ? 16 : 0,
    paddingRight: mobile ? 16 : 0,
    boxSizing: "border-box",
  };

  return <h2 style={style}>{children}</h2>;
};

H2.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default H2;
